import CourseDetail from "../../components/CourseDetail";
import { useCourseDetail } from "../../hooks/useCourseDetail";

export interface CourseDetailScreenProps {
  token: string | null;
  loaderStatus: (status: boolean) => void;
}

/**
 * Business-logic container for the Course Detail screen. All data loading,
 * search and bookmark logic live in `useCourseDetail`; this wires the resulting
 * state to the presentational `CourseDetail` component.
 */
const CourseDetailScreen = ({ token, loaderStatus }: CourseDetailScreenProps) => {
  const state = useCourseDetail(token, loaderStatus);
  return <CourseDetail {...state} />;
};

export default CourseDetailScreen;
